import React, { useState, useEffect } from 'react';
import { Sidebar } from 'primereact/sidebar';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Message } from 'primereact/message';
import { AnexosComponent } from '../../../../components/AnexosComponent'; // Ajusta la ruta
import * as generic from '../../../../components/Generico'; // Ajusta la ruta
import { ClientePnService } from '../../../../service/trust/ClientePnService';

export const GestorAnexosArbolPn = ({ visible, onHide, clipnId, toast, permss }) => {
    const [loading, setLoading] = useState(false);
    const [arbol, setArbol] = useState(null);
    const clientePnServicio = new ClientePnService();
    const [dialogAnexo, setDialogAnexo] = useState(false);
    const [anexoConfig, setAnexoConfig] = useState(null);

    // Las URLs siempre apuntan a certificacion-pn para ambos casos
    const urlsCertPn = {
        urlListado: 'ficha/trust/certificacion-pn',
        urlUpload: 'ficha/trust/certificacion-pn/store',
        udelete: 'ficha/trust/certificacion-pn/eliminar-anexo',
        urlDownload: 'ficha/trust/certificacion-pn/descarga',
        uaprobar: 'ficha/trust/certificacion-pn/aprobar',
    };

    useEffect(() => {
        if (visible && clipnId) {
            consultarCertificaciones();
        }
        // eslint-disable-next-line
    }, [visible, clipnId]);

    const consultarCertificaciones = () => {
        setLoading(true);
        setArbol(null);

        clientePnServicio.getArbolAnexos(clipnId).then(res => {
            setArbol(res.data);
        }).catch(error => {
            generic.funcSistemaError(error, toast);
        }).finally(() => {
            setLoading(false);
        });
    };

    const abrirAnexos = (tipo, idp, estado) => {
        setAnexoConfig({ tipo, idp, estado, urls: urlsCertPn, soloLectura: estado === 'FINALIZADO' });
        setDialogAnexo(true);
    };

    const actualizarEstadoRegistro = (nuevoEstado) => {
        if (!nuevoEstado || !anexoConfig) return;

        const { tipo } = anexoConfig;

        if (tipo === 'natural') {
            setArbol(prev => ({ ...prev, certPn: { ...prev.certPn, estado: nuevoEstado } }));
        } else if (tipo === 'control') {
            setArbol(prev => ({ ...prev, certControl: { ...prev.certControl, estado: nuevoEstado } }));
        }

        setAnexoConfig(prev => ({ ...prev, estado: nuevoEstado, soloLectura: nuevoEstado === 'FINALIZADO' }));
    };

    const obtenerNombreRegistro = (registro) => {
        if (!registro) return 'Sin datos';
        return `${registro.nombres || ''} ${registro.apellidos || ''}`.trim() || 'Sin datos';
    };

    const renderFila = (titulo, icono, registro, tipo) => {
        return (
            <div className="flex align-items-center justify-content-between gap-3 p-3 mb-3 surface-100 border-round shadow-1">
                <div className="flex align-items-center gap-3 overflow-hidden">
                    <i className={`${icono} text-xl text-primary flex-shrink-0`}></i>
                    <div className="overflow-hidden">
                        <span className="block font-bold text-700 text-sm md:text-base truncate">
                            {titulo}
                        </span>
                        <span className="block text-sm text-800 font-medium mt-1 truncate">
                            {obtenerNombreRegistro(registro)}
                        </span>
                        {registro?.estado && (
                            <span className="block text-xs text-500 mt-1">
                                Estado: {registro.estado}
                            </span>
                        )}
                    </div>
                </div>
                <Button icon="pi pi-folder-open" label="Anexos" className="p-button-outlined p-button-sm flex-shrink-0" style={{ width: '110px' }} onClick={() => abrirAnexos(tipo, registro.id, registro.estado)} />
            </div>
        );
    };

    return (
        <>
            <Sidebar visible={visible} onHide={onHide} position="right" style={{ width: '500px' }} className="p-sidebar-md">
                <h2 className="text-xl font-bold mb-4">Anexos: Auto-certificaciones (PN)</h2>

                {loading && <span className="block mb-3 text-600"><i className="pi pi-spin pi-spinner mr-2"></i>Cargando estructura...</span>}

                {!loading && !arbol?.certPn && (
                    <Message severity="info" text="Este cliente aún no tiene una Auto-certificación iniciada." className="w-full" />
                )}

                {!loading && arbol?.certPn && (
                    <div className="flex flex-column gap-2 mt-3">
                        <h3 className="text-lg mt-0 mb-2">Certificación Principal</h3>
                        {renderFila('Auto-certificación Persona Natural', 'pi pi-user', arbol.certPn, 'natural')}

                        {arbol?.certControl && (
                            <>
                                <h3 className="text-lg mt-4 mb-2">Persona de Control</h3>
                                {renderFila('Auto-certificación de Control', 'pi pi-star-fill', arbol.certControl, 'control')}
                            </>
                        )}
                    </div>
                )}
            </Sidebar>

            <Dialog visible={dialogAnexo} header={`Gestión de Anexos`} modal className="p-fluid modal-ssize dialog-personalizado" onHide={() => setDialogAnexo(false)} style={{ width: '800px' }}>
                {anexoConfig && (
                    <AnexosComponent tipo={anexoConfig.tipo} urls={anexoConfig.urls} idp={anexoConfig.idp} toast={toast} permss={permss} setDialogSubir={setDialogAnexo} soloLectura={anexoConfig.soloLectura} estado={anexoConfig.estado} reiniciar={(nuevoEstado) => actualizarEstadoRegistro(nuevoEstado)} />
                )}
            </Dialog>
        </>
    );
}